import { TextInput, useInputHelper, FormFieldsData } from 'framework/form';
import { Grid2 as Grid, SxProps } from '@mui/material';
import React, { useEffect } from 'react';

interface OpportunitySelectorProps {
  source: string;
  disabled?: boolean | ((values: FormFieldsData) => boolean);
  onChange?: (accountId?: string, opportunityId?: string, rawProjectId?: string) => void;
  sx?: SxProps;
}

const OpportunitySelector = ({ source, disabled, onChange, sx = { pr: 5.75 } }: OpportunitySelectorProps) => {
  const { getSource, getValue, getRawOnChangeCallback } = useInputHelper({ source });
  const parentOnChangeCallback = getRawOnChangeCallback() || (() => {});

  useEffect(() => {
    const initialValue = getValue();
    if (initialValue?.rawProjectId) {
      onChange?.(initialValue.accountId, initialValue.opportunityId, initialValue.rawProjectId);
      return;
    }

    if (initialValue?.accountId && initialValue?.opportunityId) {
      onChange?.(initialValue.accountId, initialValue.opportunityId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeCallback = (eventValue: FormFieldsData) => {
    const accountId = eventValue[`${getSource()}.accountId`] || getValue()?.accountId;
    const opportunityId = eventValue[`${getSource()}.opportunityId`] || getValue()?.opportunityId;
    onChange?.(accountId, opportunityId);
    parentOnChangeCallback?.(eventValue);
  };

  return (
    <Grid container spacing={2} size={12} sx={sx}>
      <Grid size={3}>
        <TextInput
          label="Account"
          onChangeCallback={onChangeCallback}
          source={`${source}.accountId`}
          disabled={disabled}
        />
      </Grid>
      <Grid size={3}>
        <TextInput
          label="Opportunity"
          onChangeCallback={onChangeCallback}
          source={`${source}.opportunityId`}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
};

export default OpportunitySelector;
